import * as commonConsts from '../common/Consts';
export const DIALOG_WIDTH_PERCENT = 0.9;
export const DIALOG_WIDTH = `${DIALOG_WIDTH_PERCENT * 100}%`;
export const DIALOG_HEIGHT = 'calc(100vh - 128px)';

export const MUI_DIALOG_MAX_HEIGHT = 'calc(100vh - 128px)';
export const MUI_DIALOG_MAX_HEIGHT_MINUS = (pixels) => {return 'calc(100vh - ' + (pixels + 128) + 'px)';};

export const TITLE_HEIGHT = 45;
export const TAB_CONTENT_HEIGHT = 453;
export const BUTTONS_SECTION_HEIGHT = 80;
export const TAB_CONTENT_MAX_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT + commonConsts.TITLE_HEIGHT);
export const CONTENT_HEIGHT = MUI_DIALOG_MAX_HEIGHT_MINUS(BUTTONS_SECTION_HEIGHT + TITLE_HEIGHT);

export const IMAGE_SIZE = 140;
export const IMAGE_MARGIN = 20;

export const TRANSITION_DURATION = 200;

export const ABSOLUTE_GRID_MARGIN_TOP = 30;
export const ABSOLUTE_GRID_MARGIN_LEFT = 40;
